/** Identity, readable presentation and host navigation are separate; opaque IDs are never names or URLs. */
import * as z from 'zod';
export const insightEntityTargetSchema = z.discriminatedUnion('kind', [
    z.strictObject({
        kind: z.literal('shopify-product'),
        productId: z.string().min(1),
        variantId: z.string().min(1).optional(),
    }),
    z.strictObject({ kind: z.literal('shopify-order'), orderId: z.string().min(1) }),
]);
export const insightEntitySchema = z.strictObject({
    id: z.string().min(1),
    label: z.string().min(1),
    imageUrl: z.string().nullable(),
    target: insightEntityTargetSchema.nullable().optional(),
});
/** Both analytical sources supply catalog-first metadata; the final absent-name policy lives here. */
export function buildProductInsightEntity(product) {
    return {
        id: product.productId,
        label: product.title?.trim() || 'Unnamed product',
        imageUrl: product.imageUrl,
        target: { kind: 'shopify-product', productId: product.productId },
    };
}
export function buildOrderInsightEntity(order) {
    return {
        id: order.orderId,
        label: order.name?.trim() || 'Unnamed order',
        imageUrl: null,
        target: { kind: 'shopify-order', orderId: order.orderId },
    };
}
//# sourceMappingURL=insight-entity.js.map